/*
 * Bonvelle · Rhode-laag: header.
 *
 * De header zelf beweegt met CSS op Horizons eigen attributen (data-sticky-state en
 * data-scroll-direction op #header-component, gezet door assets/header.js). Dit script doet alleen
 * wat CSS niet kan:
 *
 * 1. html.rh-klaar pas na de eerste scroll, aanraking, toets of klik, of na 500ms. Tot dan staan
 *    de overgangen van de header uit, zodat een pagina die halverwege opent (terug-knop) de header
 *    niet zichtbaar laat inschuiven. Rhode doet hetzelfde met is-header-interactive.
 *
 * 2. Sluiten met de hamburger. Een klik op een <summary> klapt de <details> meteen dicht, en dan
 *    verdwijnt het menu zonder animatie (gemeten 28-09: open=false direct na de klik). Horizons
 *    header-drawer.js haalt 'open' zelf weg zodra de overgang klaar is; wij houden de browser dus
 *    alleen tegen bij het sluiten. Openen gaat zoals altijd.
 *
 * 3. Escape op een categorie in de lade. Na Terug uit een tweede scherm staat de focus op de
 *    categorie, en Horizon sluit bij Escape de dichtstbijzijnde <details>: dat is dan die categorie,
 *    die al dicht is, dus er gebeurde niets (gemeten 29-10). Dan sluiten we de hele lade. Staat het
 *    tweede scherm open, dan gaat Horizon gewoon terug.
 *
 * Tot 29-10-2026 mat dit script ook de onderkant van de balk (--rh-lade-top), omdat het menu als
 * paneel onder de balk openviel. Sinds dan is het een lade over de volle hoogte (keuze Daan).
 */
(() => {
  const html = document.documentElement;
  const klaar = () => html.classList.add('rh-klaar');
  const opties = { once: true, passive: true, capture: true };
  // Scroll bubbelt niet, maar een luisteraar in de capture-fase op window vangt ook het scrollen
  // van .page-wrapper (Horizon scrolt op desktop dat element, niet het document).
  ['scroll', 'wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((type) => addEventListener(type, klaar, opties));
  setTimeout(klaar, 500);

  document.addEventListener(
    'click',
    (e) => {
      const summary = e.target instanceof Element ? e.target.closest('.rh-lade > details > summary') : null;
      if (summary && summary.parentElement.hasAttribute('open')) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'keyup',
    (e) => {
      if (e.key !== 'Escape' || !(e.target instanceof Element)) return;
      const categorie = e.target.closest('.rh-lade .rh-mmenu__cat');
      if (!categorie || categorie.classList.contains('menu-open')) return;
      e.stopPropagation();
      e.target.closest('header-drawer')?.close();
    },
    true
  );
})();
